// Copyright (c) Ping. All rights reserved.

import type { TaskId, TaskSelection } from './types';

/** Switch to active mode with an empty selection set. */
export function enterSelection(): TaskSelection {
  return { mode: 'active', selectedIds: new Set<TaskId>() };
}

/** Drop selection mode entirely. */
export function clearSelection(): TaskSelection {
  return { mode: 'inactive' };
}

/**
 * Toggle one id in/out of the active selection. No-op when the selection
 * is `inactive` — the host must call {@link enterSelection} first.
 */
export function toggleSelection(selection: TaskSelection, id: TaskId): TaskSelection {
  if (selection.mode === 'inactive') {
    return selection;
  }
  const next = new Set(selection.selectedIds);
  if (next.has(id)) {
    next.delete(id);
  } else {
    next.add(id);
  }
  return { mode: 'active', selectedIds: next };
}

/** Convenience for tests / toolbars. Returns 0 when inactive. */
export function selectionCount(selection: TaskSelection): number {
  return selection.mode === 'active' ? selection.selectedIds.size : 0;
}
